import { NavLink } from 'react-router-dom';
import samRock1 from '../../assets/samRock1.webp';
import samRock2 from '../../assets/samRock2.webp';
import samRock3 from '../../assets/samRock3.webp';
import styles from './HowCanIHelpSection.module.css';

const helpOptions = [
  {
    id: 1,
    title: 'acting résumé',
    buttonText: 'Read It',
    img: samRock1,
    route: '/acting-resume',
    external: false,
  },
  {
    id: 2,
    title: 'commercial reel',
    buttonText: 'Watch It',
    img: samRock3,
    route: '/commercial-reel',
    external: false,
  },
  {
    id: 3,
    title: 'media coverage',
    buttonText: 'Read It',
    img: samRock2,
    route: 'https://dailybruin.com/2019/02/11/alumna-singer-draws-inspiration-from-diversity-seeks-to-uplift-asian-voices',
    external: true,
  },
];

const HowCanIHelpSection = () => {
  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>HOW CAN I HELP YOU?</h2>
      <div className={styles.flexWrapper}>
        <div className={styles.leftColumn}>
          {[helpOptions[0], helpOptions[2]].map(({ id, title, buttonText, img, route, external }) =>
            external ? (
              <a
                key={id}
                href={route}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.card}
              >
                <img src={img} alt={title} className={styles.image} />
                <h3 className={styles.title}>{title}</h3>
                <button className={styles.actionButton}>{buttonText}</button>
              </a>
            ) : (
              <NavLink to={route} key={id} className={styles.card}>
                <img src={img} alt={title} className={styles.image} />
                <h3 className={styles.title}>{title}</h3>
                <button className={styles.actionButton}>{buttonText}</button>
              </NavLink>
            )
          )}
        </div>
        <div className={styles.rightColumn}>
          <NavLink to={helpOptions[1].route} className={styles.card}>
            <img src={helpOptions[1].img} alt={helpOptions[1].title} className={styles.image} />
            <h3 className={styles.title}>{helpOptions[1].title}</h3>
            <button className={styles.actionButton}>{helpOptions[1].buttonText}</button>
          </NavLink>
        </div>
      </div>
    </section>
  );
};

export default HowCanIHelpSection;
